import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Função para inicializar o Google Tag Manager
export const initGTM = (containerId) => {
  if (!containerId) {
    console.warn('Google Tag Manager Container ID não fornecido');
    return;
  }

  // Verificar se o GTM já foi inicializado
  if (window.dataLayer && window.dataLayer.find(item => item.event === 'gtm.js')) {
    return;
  }

  // Inicializar o dataLayer se não existir
  window.dataLayer = window.dataLayer || [];
  
  // Função para enviar eventos para o GTM
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
};

// Hook para rastrear mudanças de página
export const usePageTracking = (containerId) => {
  const location = useLocation();

  useEffect(() => {
    if (window.dataLayer && containerId) {
      // Enviar evento de mudança de página para o GTM
      window.dataLayer.push({
        event: 'page_view',
        page_title: document.title,
        page_location: window.location.href,
        page_path: location.pathname,
      });
    }
  }, [location, containerId]);
};

// Componente para Google Tag Manager
const GoogleTagManager = ({ containerId }) => {
  useEffect(() => {
    if (containerId) {
      initGTM(containerId);
    }
  }, [containerId]);

  usePageTracking(containerId);

  return null; // Este componente não renderiza nada
};

export default GoogleTagManager;
